import React from 'react';
import '../../styles/components/custom-title.scss';

export class CustomTitle extends React.Component {
  render() {
    const IconComponent = this.props.icon;

    return (
      <div className="custom-title-wrapper">
        <div className="custom-title-container">
          <div className="title-content">
            {IconComponent && (
              <div className="title-icon">
                <IconComponent size={18} strokeWidth={1.5} />
              </div>
            )}
            <h2 className="title-text">{this.props.title}</h2>
          </div>

          {this.props.subtitle && <p className="title-subtitle">{this.props.subtitle}</p>}
        </div>
      </div>
    );
  }
}
